import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { ApiRequestPost } from "../../../data/network/services/ApiRequestPost";
import { removeAllAccountsAction } from "../../../data/redux/action/add_customer/addAccountsAction";
import ResizeListener from "../../../utility/ResizeListener";
import { CustomerHeader } from "../../../utility/TableHeaders";
import { CustomButton } from "../../components/customButton/CustomButton";
import CustomModal from "../../components/customModal/CustomModal";
import CustomTable from "../../components/customTable/CustomTable";
import TopHeaderComponent from "../../components/TopHeaderComponent";
import { Add } from "../../resources/assetsManager";
import { SUCCESS } from "../../resources/constantsManager";
import AddCustomerModalIndex from "./add_customer";

function Customers() {
  const { width, height } = ResizeListener();
  const [data, setData] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [viewMoreData, setViewMoreData] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [offset, setOffset] = useState(0);
  const [onClickAddCustomer, setOnClickAddCustomer] = useState(false);
  const [isTableDataError, setIsTableDataError] = useState(false);

  const dispatch = useDispatch();
  const getAllCustomers = (page, size, keyword) => {
    ApiRequestPost.getAllCustomers(page, size, keyword)
      .then((res) => {
        if (res.status === SUCCESS) {
          setData(res.data.content);
          setTotalElements(res.data.totalElements);
          setTotalPages(res.data.totalPages);
          setIsTableDataError(false);
        } else {
          setIsTableDataError(true);
        }
      })
      .catch((err) => {
        setIsTableDataError(true);
      });
  };
  const navigate = useNavigate();
  useEffect(() => {
    getAllCustomers(0, 10);
  }, []);
  return (
    <>
      <TopHeaderComponent
        headerName="Customer Management"
        isSearchRequired={true}
        inputStyle={{
          width: width * 0.3,
          minWidth: 300,
        }}
        textStyle={{
          fontWeight: "500",
        }}
        placeholder="Search by Name, Virtual ID ,UPI ID ...."
        onClickBack={() => {
          navigate(-1);
        }}
        onSearchStart={(val) => {
          setOffset(0);
          getAllCustomers(0, 10, val);
        }}
        showFilter={false}
        showDownload={false}
        showDeveloper={
          <CustomButton
            title="Add Customer"
            styles={{
              border: "none",
              width: "100%",
              borderRadius: 6,
              minWidth: 150,
            }}
            icon={Add}
            onClick={() => {
              setOnClickAddCustomer(true);
            }}
          />
        }
        validator="email"
      />
      <div
        style={{
          marginTop: "20px",
          height: "70%",
        }}
      >
        <CustomTable
          headers={CustomerHeader}
          totalElements={totalElements}
          data={data}
          totalPages={totalPages}
          handlePaginate={(page) => {
            setOffset(page);
            getAllCustomers(page, 10);
          }}
          offset={offset}
          isFilterApplied={isFilterApplied}
          onClickViewCustomer={(data) => {
            console.log(data);
            navigate(`/customers/${data?.firstName + data?.lastName}`, {
              state: {
                customerDetails: data,
              },
            });
          }}
          tableStyle={{
            minHeight: 300,
            height: height * 2,
          }}
          isTableDataError={isTableDataError}
        />
      </div>

      {onClickAddCustomer && (
        <CustomModal
          open={onClickAddCustomer}
          onClose={() => {
            setOnClickAddCustomer(false);
            dispatch(removeAllAccountsAction([]));
          }}
        >
          <AddCustomerModalIndex
            onClose={() => {
              setOnClickAddCustomer(false);
              getAllCustomers(0, 10);
              dispatch(removeAllAccountsAction([]));
            }}
          />
        </CustomModal>
      )}
    </>
  );
}

export default Customers;
